<template lang="pug">
  b-modal#editFunction(
  ref="editFunction"
  :title="$t('ui.combine.edit_function')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')").mb-3
        div.form-control.form-control-sm.disabled {{ getFunctionId }}
      b-form-group(:label="$t('ui.name')").mb-0
        DebounceInput(
          size="sm"
          ref="dataEdit_functionName"
          required
          type="text"
          :dirty="$v.dataEdit_functionName.$dirty"
          :error="$v.dataEdit_functionName.$error"
          v-model.trim.lazy="$v.dataEdit_functionName.$model"
          :disabled="loading"
          @focus.native="$event.target.select()"
          :maxLength="$v.dataEdit_functionName.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataEdit_functionName" :name="$t('ui.name')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    functionId: "",
    functionName: ""
  },
  data() {
    return {
      dataEdit_functionName: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    getFunctionId: function() {
      return this.functionId;
    }
  },
  validations: {
    dataEdit_functionName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(100)
    }
  },
  watch: {
    functionName: function(newVal) {
      this.dataEdit_functionName = newVal;
    }
  },
  methods: {
    test: function(event) {
      alert("123" + event);
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editFunctionUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.function,
          target_function_id: this.functionId,
          new_function_name: this.dataEdit_functionName
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.functionId, this.dataEdit_functionName);
                  this.$refs.editFunction.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_function", this.feedback.status);
                  this.$refs.editFunction.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.dataEdit_functionName = this.functionName;
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataEdit_functionName.$el.focus();
    }
  }
};
</script>
